module.exports = __webpack_public_path__ + "static/img/cab-celestion.a940e4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/cab/cab-celestion.jpg
// module id = AROO
// module chunks = 12